import { render, staticRenderFns } from "./FormOrganisationContacts.vue?vue&type=template&id=97ec4fd6&scoped=true&"
import script from "./FormOrganisationContacts.vue?vue&type=script&lang=true&"
export * from "./FormOrganisationContacts.vue?vue&type=script&lang=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ec4fd6",
  null
  
)

export default component.exports